var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    { attrs: { id: _vm.id, options: _vm.options, title: "Import completed" } },
    [
      _c(
        "ul",
        { staticClass: "flex flex-col items-start" },
        [
          _vm.watchedMovies.length > 0
            ? _c(
                "ImportResultModalItem",
                {
                  attrs: { icon: "checkmark", "icon-class": "text-green-600" },
                  on: { inspect: _vm.inspectWatched }
                },
                [
                  _c("strong", { staticClass: "font-semibold" }, [
                    _vm._v(_vm._s(_vm.watchedMovies.length))
                  ]),
                  _vm._v(" watched movies have been added to your collection. ")
                ]
              )
            : _vm._e(),
          _vm.pendingMovies.length > 0
            ? _c(
                "ImportResultModalItem",
                {
                  attrs: { icon: "time", "icon-class": "text-blue-600" },
                  on: { inspect: _vm.inspectPending }
                },
                [
                  _c("strong", { staticClass: "font-semibold" }, [
                    _vm._v(_vm._s(_vm.pendingMovies.length))
                  ]),
                  _vm._v(
                    " movies have been added to your collection to watch later. "
                  )
                ]
              )
            : _vm._e(),
          _vm.log.ignored.length > 0
            ? _c(
                "ImportResultModalItem",
                {
                  attrs: { icon: "info", "icon-class": "text-blue-600" },
                  on: { inspect: _vm.inspectIgnored }
                },
                [
                  _c("strong", { staticClass: "font-semibold" }, [
                    _vm._v(_vm._s(_vm.log.ignored.length))
                  ]),
                  _vm._v(" were ignored. ")
                ]
              )
            : _vm._e(),
          _vm.log.unprocessed.length > 0
            ? _c(
                "ImportResultModalItem",
                {
                  attrs: { icon: "info", "icon-class": "text-blue-600" },
                  on: { inspect: _vm.inspectUnprocessed }
                },
                [
                  _c("strong", { staticClass: "font-semibold" }, [
                    _vm._v(_vm._s(_vm.log.unprocessed.length))
                  ]),
                  _vm._v(
                    " weren't processed because you stopped the operation. "
                  )
                ]
              )
            : _vm._e(),
          _vm.log.invalid.length > 0
            ? _c(
                "ImportResultModalItem",
                {
                  attrs: { icon: "error", "icon-class": "text-red-600" },
                  on: { inspect: _vm.inspectInvalid }
                },
                [
                  _c("strong", { staticClass: "font-semibold" }, [
                    _vm._v(_vm._s(_vm.log.invalid.length))
                  ]),
                  _vm._v(" contained validation errors. ")
                ]
              )
            : _vm._e(),
          _vm.log.failed.length > 0
            ? _c(
                "ImportResultModalItem",
                {
                  attrs: { icon: "error", "icon-class": "text-red-600" },
                  on: { inspect: _vm.inspectFailed }
                },
                [
                  _c("strong", { staticClass: "font-semibold" }, [
                    _vm._v(_vm._s(_vm.log.failed.length))
                  ]),
                  _vm._v(" failed on import. ")
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "BaseButton",
        {
          staticClass:
            "bg-primary-500 text-white self-center justify-center w-24 hover:bg-primary-700",
          on: {
            click: function($event) {
              return _vm.close(true)
            }
          }
        },
        [_vm._v(" OK ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }